import { FormEvents, FormEventHandler } from '../events/form_event_handler';
import { dataStoreRouteLoader } from '../../datastore/datastore_route_loader';
import { FormAPI } from 'lecom-api';

function execute (params) {
	var initialValuesDataStoreRoute = params.initialValuesDataStoreRoute;
	var formAPI = FormAPI.form(params.id);

	formAPI.publish(FormEvents.INITIAL_VALUES_LOAD);
	return new Promise((resolve, reject) => {
		return dataStoreRouteLoader.load(initialValuesDataStoreRoute)
		.then(handleLoadSuccess.bind(this, resolve, reject))
		.catch(handleLoadError.bind(this, formAPI, reject));
	});
};

function handleLoadSuccess (resolve, reject, dataStoreResponse) {
	if (!dataStoreResponse.hasOwnProperty("resources")) handleLoadError(reject, dataStoreResponse);
	resolve(dataStoreResponse.resources);
};

function handleLoadError (formAPI, reject, reason) {
	formAPI.publish(FormEvents.INITIAL_VALUES_LOAD_ERROR, reason);
	reject(reason);
};

export const LoadInitialValuesActionHandler = {
	execute
};

export default LoadInitialValuesActionHandler;
